// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__292hF","assignButton":"CreateEditEquipmentSchedule_assignButton__3HK_u"};